<template>
  <div id="Warehousetable">
    <el-table
      :data="tableData"
      @row-dblclick="rowdblclick(row, column, event)"
      @row-click="rowclick"
      highlight-current-row
      @selection-change="handleSelectionChange"
      border
      :fit="asdaaf"
      style="width: 100%;"
      :height="max"
      class="tabone_sty"
      :header-cell-style="{background:'#eef1f6',color:'#000',fontSize:'14px',height:'37px',padding:'0',fontWeight: 'bold'}"
    >
      <el-table-column width="80" height="500" align="center" prop="BarCode" fixed="left">
        <template slot="header">
          <i
            :class="isInner==true?'el-icon-s-tools':'el-icon-refresh-left'"
            @click="clickIcon"
            style="color:#2594ff;font-size:18px"
          ></i>
        </template>
        <template slot-scope="scope">{{scope.$index +1 }}</template>
      </el-table-column>
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column width="50" align="center" label="类型">
        <template slot-scope="scope">
          <i
            :class="scope.row.IsDir?'el-icon-folder':'el-icon-tickets'"
            style="color:#e9cb70;font-size:18px"
          ></i>
        </template>
      </el-table-column>
      <template v-for="(obj,index) in Header">
        <el-table-column
          align="center"
          :index="index"
          :key="index"
          :prop="obj.Key"
          :label="obj.Rename"
          v-if="obj.Key!='IsDir'"
        ></el-table-column>
      </template>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPages"
      :page-sizes="[10, 20,50,100]"
      :page-size="pageSizes"
      layout="total, sizes,prev, pager, next, jumper"
      :total="totals"
    ></el-pagination>
  </div>
</template>

<script>
// import local from "@/utils/local.js";
// import session from "@/utils/session.js";
// import loginVue from "@/views/Login/login.vue";
export default {
  name: "Warehousetable",
  data() {
    return {
      data: this.tableData,
      asdaaf: true,
      max: this.maxs,
      isInners: this.isInner,
      IfShows: this.IfShow,
      ObtainHeader: this.Header,
      currentPage: this.currentPages, //当前页码
      total: this.totals, //总页数
      pageSize: this.pageSizes //每页显示数量
    };
  },
  props: {
    totals: Number,
    pageSizes: Number,
    currentPages: Number,
    tableData: Array,
    isInner: {
      type: Boolean,
      default: true
    },
    IfShow: {
      type: Boolean,
      default: false
    },
    maxs: {
      type: String,
      default: "400"
    },
    Header: Array
  },
  methods: {
    // 双击一行
    rowdblclick(obj) {
      this.$emit("rowdblclick", obj);
    },
    // 单击某一行
    rowclick(obj) {
      this.$emit("rowclick", obj);
    },
    // 点击设置
    clickIcon() {
      this.$emit("clickIcon");
    },
    handleSelectionChange(val) {
      this.$emit("handleSelectionChange", val);
    },
    // 分页
    handleSizeChange(val) {
      // 赋值
      this.$emit("handleSizeChange", val);
    },
    handleCurrentChange(val) {
      // 赋值
      this.$emit("handleCurrentChange", val);
    }
  },
  watch: {
    // ObtainHeader: {
    //   handler(newValue, oldValue) {
    //     // console.log(newValue,oldValue);
    //     this.ObtainHeader = newValue;
    //   },
    //   deep: true
    // }
  },
  created() {}
};
</script>

<style lang="less">
.el-table__fixed-header-wrapper {
  z-index: 25;
}
.btn {
  border: none;
  background-color: transparent;
  color: #409eff;
  font-size: 12px;
  margin-right: 15px;
  padding: 7px 0;
}
.tabone_sty {
  .input_sty {
    background: inherit;
    border: 0;
    outline: 0;
    width: 100%;
    height: 100%;
    display: block;
    box-sizing: border-box;
    padding: 0 10px;
    color: #606266;
  }
}
.el-table__fixed-right {
  width: 130px;
  height: 100% !important;
  right: 0px !important;
}
// .el-button--small{
//   padding: 0 !important;
// }
.el-button {
  font-size: 12px !important;
}
// .is-center {
//   padding: 6px 0 !important;
// }
.el-table__fixed {
  height: 405px;
}
.el-table .cell {
  // overflow: hidden !important;
  white-space: nowrap !important;
  // font-size: 14px;
}
// .tabone_sty td {
//   padding: 0 0 !important;
// }
// .tabone_sty th {
//   padding: 0 !important;
// }
.breadcrumb {
  ul {
    display: flex;
    li {
      list-style: none;
    }
  }
}
.el-table__header-wrapper {
  width: 101% !important;
}
.el-pagination {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Table/housetable/housetable.vue